export default "__VITE_ASSET__BJjNif5o__"